import { MailOutlined } from "@ant-design/icons";
import { Button, Form, Grid, Input, Typography } from "antd";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToken } from "../../hooks/useToken";
import { ThemeSwitcher, useTheme } from "../../providers/ThemeProvider";
const { useBreakpoint } = Grid;
const { Text, Title, Link } = Typography;

export function Recovery() {
  const { token } = useToken();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const { theme, message } = useTheme();
  const [isLoading, setLoading] = useState<boolean>(false);

  return (
    <div
      style={{
        width: screens.lg ? "50%" : "100%",
        minWidth: "320px",
        height: "100%",
        backgroundColor: token.colorBgContainer,
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          margin: "0 auto",
          padding: screens.md
            ? `${token.paddingXL}px`
            : `${token.sizeXXL}px ${token.padding}px`,
          width: "380px",
        }}
      >
        <div style={{ position: "absolute", top: "20px", left: "46.5%" }}>
          <ThemeSwitcher />
        </div>
        <div
          style={{
            marginBottom: token.marginXL,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={
              theme == "DARK"
                ? "/assets/logo_dark.png"
                : "/assets/logo_white.png"
            }
            alt=""
            style={{
              width: "97px",
            }}
          />
        </div>
        <div
          style={{
            marginBottom: token.marginXL,
          }}
        >
          <Title
            style={{
              fontSize: screens.md
                ? token.fontSizeHeading2
                : token.fontSizeHeading3,
              marginBottom: screens.lg ? 0 : "",
              textAlign: "center",
            }}
          >
            Forgot password?
          </Title>
          <Text
            style={{
              color: token.colorTextSecondary,
            }}
          >
            Enter your email address to receive a password reset link.
          </Text>
        </div>
        <Form
          name="normal_login"
          initialValues={{
            remember: true,
          }}
          onFinish={(values) => {
            console.log("Received values of form: ", values);
            setLoading(true);
            sendPasswordResetEmail(getAuth(), values.email)
              .then(() => {
                setLoading(false);
                message.success(
                  "Password reset email sent. Please check your inbox."
                );
              })
              .catch((err) => {
                setLoading(false);
                message.error(err.message);
              });
          }}
          layout="vertical"
          requiredMark="optional"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                type: "email",
                required: true,
                message: "Please input your Email!",
              },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Email" />
          </Form.Item>
          <Form.Item style={{ marginBottom: "0px" }}>
            <Button
              loading={isLoading}
              block={true}
              type="primary"
              htmlType="submit"
              style={{ boxShadow: `0 2px 0 ${token.boxShadow}` }}
            >
              <Text style={{ color: token.Button?.primaryColor }}>
                Reset Password
              </Text>
            </Button>
            <div
              style={{
                marginTop: token.marginLG,
                textAlign: "center",
                width: "100%",
              }}
            >
              <Text
                style={{
                  color: token.colorTextSecondary,
                }}
              >
                Remember your password?
              </Text>{" "}
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  navigate("/signin");
                }}
                href="/signin"
              >
                Log in
              </Link>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
